import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import useEmployeeContext from "./contexts/useEmployeeContext";
import UploadPayStubButton from "./UploadPayStubButton";

export const showPayStub = (employee) => {
  if (!employee || employee.enrollmentStatus) {
    return false;
  }

  return true;
};

const PayStub = () => {
  const { employee } = useEmployeeContext();
  if (!employee) {
    return <></>;
  }
  return (
    <div className="bg-pink px-4 py-3 font-secondary">
      <Row>
        <Col sm={8}>
          <div>
            <div className="fw-bold font-size-5 mb-1">Upload Pay Stub</div>
            <div className="font-secondary">
              To assure funds will be deposited into the correct bank account,{" "}
              please verify you bank using our partner Dwolla.
            </div>
          </div>
        </Col>
        <Col
          sm={4}
          className="d-flex justify-content-center align-items-center"
        >
          {!employee.enrollmentStatus && <UploadPayStubButton />}
          {employee.enrollmentStatus && (
            <div className="d-flex align-items-center">
              <div className="fw-bold">Complete</div>
              <FaCheckCircle className="ms-1" />{" "}
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PayStub;
